import React from "react";
import {
  Select,
  FormControl,
  Checkbox,
  ListItemText,
  MenuItem,
} from "@mui/material";

const FilterColumnSelector = ({
  filterableColumns,
  selectedColumns,
  setSelectedColumns,
  placeholder = "Select columns to filter by...",
  minWidth = "200px",
  maxWidth = "300px",
  style = {},
}) => {
  return (
    <div style={style}>
      <div
        className="d-flex justify-content-between align-items-center mb-1 mt-2"
        style={{
          minWidth: minWidth,
          maxWidth: maxWidth,
        }}
      >
        <small style={{ color: "#B23434", fontWeight: "bold" }}>
          Filter Columns
        </small>
        <div className="d-flex gap-2">
          <span
            onClick={() =>
              setSelectedColumns(filterableColumns.map((col) => col.id))
            }
            style={{
              color: "#B23434",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: "500",
              textDecoration: "underline",
            }}
          >
            Select All
          </span>
          <span style={{ color: "#ccc", fontSize: "12px" }}>|</span>
          <span
            onClick={() => setSelectedColumns([])}
            style={{
              color: "#B23434",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: "500",
              textDecoration: "underline",
            }}
          >
            Clear All
          </span>
        </div>
      </div>
      <FormControl
        sx={{
          minWidth: minWidth,
          maxWidth: maxWidth,
          flexShrink: 0,
          width: "100%",
        }}
        size="small"
      >
        <Select
          labelId="column-select-label"
          multiple
          displayEmpty
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#B23434",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#B23434",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#B23434",
            },
            color: "#606060",
          }}
          value={selectedColumns}
          onChange={(e) =>
            setSelectedColumns(
              typeof e.target.value === "string"
                ? e.target.value.split(",")
                : e.target.value
            )
          }
          renderValue={(selected) =>
            selected.length === 0
              ? placeholder
              : filterableColumns
                  .filter((col) => selected.includes(col.id))
                  .map((col) => col.label)
                  .join(", ")
          }
        >
          {filterableColumns.map((col) => (
            <MenuItem key={col.id} value={col.id}>
              <Checkbox checked={selectedColumns.indexOf(col.id) > -1} />
              <ListItemText primary={col.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default FilterColumnSelector;
